import { Box, Stack, Typography, useTheme, styled } from "@mui/material"
import { useTranslation } from "react-i18next";
import { createColorFilteredComponent } from 'helpers/styledHelpers';

const StyledTitleTypography = styled(Typography)({
  fontWeight: 'bold'
});

const StyledSubtitleTypography = createColorFilteredComponent<{ $color: string }>(Typography)(({ $color }) => ({
  fontWeight: 'bold',
  color: $color
}));

export const UserProfileHeader = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return <Stack flexDirection={'row'} display='flex' height='15%' alignItems='end' paddingBottom={theme.spacing(4)}>
        <Stack height='100%' spacing={theme.spacing(2)}>
            <Box>
                <StyledTitleTypography variant="h5">{t('profile.profile')}</StyledTitleTypography>
                <StyledSubtitleTypography variant="h6" $color={theme.palette.text.secondary}>{t('profile.windowDescription')}</StyledSubtitleTypography>
            </Box>
            <Box>
                <Typography variant="body1">{t('profile.displayNameDescription')}</Typography>
            </Box>
        </Stack>
    </Stack>
}